import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ReceiptItemsService } from './receipt-items.service';
import { styles } from './styles';
import { emailStyles } from './stylesEmailAttachment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FetchImageBase64FromUrl } from 'src/app/shared/fetch-image-to-base64.service';
import { PrepareHtmlForExport } from 'src/app/shared/prepare-html-to-export.service';
import { PrintPage } from 'src/app/shared/print-page-section.service';
import * as html2pdf from 'html2pdf.js';
import { ViewProductInfoHandlerService } from '../../buyer/services/view-product-info-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../shared/services/language.service';
import { isPlatformBrowser } from '@angular/common';
import { ReceiptViewData, TransactionReceiptResponse } from './types';
import { GetTransactionsReceiptService } from '../../buyer/services/get-transaction-receipt.service';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
})
export class ReceiptComponent implements OnInit {
  data: ReceiptViewData;
  isInquireReceipt: boolean = false;
  dynamicMargin = {};

  constructor(
    public receiptItemsService: ReceiptItemsService,
    private snack: MatSnackBar,
    private router: Router,
    private fetchImage: FetchImageBase64FromUrl,
    private preparePage: PrepareHtmlForExport,
    private printPage: PrintPage,
    public vpihs: ViewProductInfoHandlerService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private getTransactionsReceiptService: GetTransactionsReceiptService,
    @Inject(PLATFORM_ID) private platformID
  ) {
    this.data = {
      items: [],
      vpihs: {
        currency: '',
        subTotal: 0,
        taxes: 0,
        fees: 0,
        donation: 0,
        discount: 0,
        date: null,
        refNum: '',
      },
      business: {
        logo: '',
        name: '',
        cs_phone: '',
        cs_email: '',
        logoBase64: ''
      },
    };
  }

  async ngOnInit() {
    try {
      const trxRefNum = this.route.snapshot.paramMap.get('trxRefNum');
      this.isInquireReceipt = trxRefNum ? true : false;
      this.setLanguage();

      if (this.isInquireReceipt) {
        const whatsappBtn =  document.getElementById('whatsapp-chat-widget');
        if(whatsappBtn) whatsappBtn.style.display = 'block';
        this.dynamicMargin["marginTop"] = '80px',
        this.getTransactionsReceiptService.setParams({
          trxProviderRefNum: trxRefNum,
        });
        const dataResponse =
          (await this.getTransactionsReceiptService.make()) as TransactionReceiptResponse;
        this.data = dataResponse.data;

        if(!this.data) throw new Error("Receipt failed to load data, Receipt dose not exists on the server.")
      } else {
        if (!isPlatformBrowser(this.platformID)) return;
        this.vpihs;
        this.receiptItemsService;
        const localStorageVpihs = JSON.parse(localStorage.getItem('vpihs'));
        const viewInfoObject = JSON.parse(localStorage.getItem('viewInfoObject'));

        if(localStorageVpihs && viewInfoObject){
          this.data = this.setVpihsVariables(localStorageVpihs, viewInfoObject);
        }else {
          this.data = this.setVpihsVariables(this.vpihs, this.vpihs.viewInfoObject);
        }

        if (!this.data?.vpihs) throw new Error('Receipt failed to load data, empty local storage data.')
        this.clearLocalStorage();
        this.data.business.logoBase64 = (await this.fetchImage.fetchBase64ImageFromUrl(
          this.data.business.logo
        )) as string;
      }
    } catch (error) {
      console.log('receipt error', error);
      this.router.navigate(['/']);
      this.snack.open(
        this.translate.instant('Sellers.Products.FailedToLoadReceipt'),
        null,
        {
          duration: 5000,
        }
      );
    }
  }

  setLanguage() {
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
  }
  setVpihsVariables(localStorageVpihs: any, viewInfoObject: any){
    this.vpihs.setViewInfoObject(viewInfoObject);
    this.vpihs.total = localStorageVpihs.total;
    this.vpihs.discount = localStorageVpihs.discount;
    this.vpihs.fees = localStorageVpihs.fees;
    this.vpihs.taxes = localStorageVpihs.taxes;
    this.vpihs.subTotal = localStorageVpihs.subTotal;

    this.receiptItemsService.setReceiptItems();
    return {
      items: this.receiptItemsService.items,
      vpihs: this.vpihs,
      business: this.receiptItemsService.vpihs.viewInfoObject.product.Business
    }
  }

  clearLocalStorage(): void {
    localStorage.removeItem('vpihs');
    localStorage.removeItem('viewInfoObject');
  }

  print() {
    this.printPage.print(this.getReceiptBody());
  }

  pdf() {
    this.exportPdfExport(this.getReceiptBody(), 'Receipt');
  }

  exportPdfExport(htmlPage: string, filename: string) {
    window.scrollTo(0, 0);
    let element = document.createElement('page');
    element.innerHTML = htmlPage;
    let opt = {
      margin: 10,
      filename: `${filename}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
      jsPDF: { format: 'a4' },
    };
    setTimeout(() => {
      html2pdf().set(opt).from(element).save();
    }, 4000);
  }

  getReceiptBody() {
    const printContents = document.getElementById('print-section')?.innerHTML;
    return this.preparePage.getPage(printContents, styles);
  }
  async getReceiptBodyForAttachment() {
    this.data.business =
      this.receiptItemsService.vpihs.viewInfoObject.product.Business;
    this.data.business.logoBase64 = await this.fetchImage.fetchBase64ImageFromUrl(
      this.data.business?.logo
    ) as string;

    const printContents = document.getElementById('print-section')?.innerHTML;
    return this.preparePage.getPageForEmail(printContents, emailStyles);
  }
}
